import { Routes, mapToCanActivate } from '@angular/router';
import { AdyenOnboardingComponent } from './adyen-onboarding/adyen-onboarding.component';
import { LoginComponent } from './auth/components/login/login.component';
import { AuthLoadedGuard } from './auth/services/auth-loaded.guard';
import { DhlOnboardingComponent } from './dhl-onboarding/dhl-onboarding.component';
import { EmptyComponent } from './empty/empty.component';
import { KpisComponent } from './kpis/kpis.component';
import { TransactionsComponent } from './transactions/transactions.component';

export const routes: Routes = [
    { path: 'login', component: LoginComponent, data: { title: 'Login' } },
    {
        path: 'kpis',
        component: KpisComponent,
        canActivate: mapToCanActivate([AuthLoadedGuard]),
        data: { title: 'KPIs' }
    },
    {
        path: 'paymentMethods',
        component: AdyenOnboardingComponent,
        canActivate: mapToCanActivate([AuthLoadedGuard]),
        data: { title: 'Bezahlmethoden' }
    },
    {
        path: 'logistics/dhl-de',
        component: DhlOnboardingComponent,
        canActivate: mapToCanActivate([AuthLoadedGuard]),
        data: { title: 'DHL Konfiguration' }
    },
    {
        path: 'transactions',
        component: TransactionsComponent,
        canActivate: mapToCanActivate([AuthLoadedGuard]),
        data: { title: 'Kontoübersicht & Transaktionen' }
    },
    {
        path: '**',
        component: EmptyComponent,
        canActivate: mapToCanActivate([AuthLoadedGuard]),
        data: { title: 'Merchant Cockpit' }
    }
];
